<template>
  <form
    :id="id"
    :novalidate="novalidate"
    :class="[
      {
        'form-inline': inline,
        'was-validated': validated
      }
    ]"
  >
    <slot />
  </form>
</template>

<script>
export default {
  name: 'BForm',
  props: {
    id: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    validated: {
      type: Boolean,
      default: false
    }
  }
}
</script>
